import {
  HierarchiqueIcon,
  Hierarchique,
  MatricielleIcon,
  Matricielle,
  ReseauxIcon,
  Reseaux,
  MatricielleReseauxIcon,
  MatricielleAndReseaux,
  HolacratiqueIcon,
  Holacratique
} from '@assets/IconeSvg';

const settings = localStorage.getItem('settingsEnterprise');
let settingsEnterprise = JSON.parse(settings);

export const Constants = {    
	_statusPostesRecruitment: {
    actif: {
      name: 'ACTIF',
      label: 'Actif'
    },
    draft: {
      name: 'BROUILLON',
      label: 'A terminer'
    },
    inactif: {
      name: 'INACTIF',
      label: 'Inactif'
    }
  }
};

export const listActivitiesArea = [
  {
    _id: "1",
    label: "Automobile"
  },
  {
    _id: "2",
    label: "Aérospatiale et défense"
  },
  {
    _id: "3",
    label: "Architecture, urbanisme et design"
  },
  {
    _id: "4",
    label: "Arts, spectacle et loisir"
  },
  {
    _id: "5",
    label: "Chimie, biologie et biotechnologie"
  },
  {
    _id: "6",
    label: "Commerce de détail"
  },
  {
    _id: "7",
    label: "Construction"
  },
  {
    _id: "8",
    label: "Cosmétiques"
  },
  {
    _id: "9",
    label: "Cuir, textile et habillement",
  },
  {
    _id: "10",
    label: "Environnement et aménagement du territoire",
  },
  {
    _id: "11",
    label: "Évènementiel",
  },
  {
    _id: "12",
    label: "Finance, comptabilité et assurance",
  },
  {
    _id: "13",
    label: "Hébergement, alimentation et tourisme",
  },
  {
    _id: "14",
    label: "Journalisme",
  },
  {
    _id: "15",
    label: "Mine, pétrole et énergies",
  },
  {
    _id: "16",
    label: "Relations publiques",
  },
  {
    _id: "17",
    label: "Restauration",
  },
  {
    _id: "18",
    label: "Radio et télévision",
  },
  {
    _id: "19",
    label: "Secteur de la santé",
  },
  {
    _id: "20",
    label: "Services professionnels, scientifiques et techniques",
  },
  {
    _id: "21",
    label: "Services publics et gouvernement",
  },
  {
    _id: "22",
    label: "Secteur pharmaceutique",
  },
  {
    _id: "23",
    label: "Services sociaux, éducatifs et juridiques",
  },
  {
    _id: "24",
    label: "Secteur maritime et navale",
  },
  {
    _id: "25",
    label: "Secteur immobilier",
  },
  {
    _id: "26",
    label: "Secteur des transports et machinerie",
  },
  {
    _id: "27",
    label: "Secteur touristique",
  },
  {
    _id: "28",
    label: "Publicité, marketing et relations publiques",
  },
];

export const listActivitiesField = [
  {
    _id: "1",
    label: "Arts, mode, cinéma et muséologie",
  },
  {
    _id: "2",
    label: "Commerce et offres de services diverses",
  },
  {
    _id: "3",
    label: "Comptabilité, finances et assurance",
  },
  {
    _id: "4",
    label: "Construction et fabrication",
  },
  {
    _id: "5",
    label: "Droit et fiscalité",
  },
  {
    _id: "6",
    label: "Génie, sciences et techniques scientifiques",
  },
  {
    _id: "7",
    label: "Marketing, communication, design et création",
  },
  {
    _id: "8",
    label: "Ressources humaines et relations industrielles",
  },
  {
    _id: "9",
    label: "Restauration, hôtellerie, tourisme et loisirs",
  },
  {
    _id: "10",
    label: "Sécurité, surveillance et protection",
  },
  {
    _id: "11",
    label: "Secteur de la Santé",
  },
  {
    _id: "12",
    label: "Soutien administratif",
  },
  {
    _id: "13",
    label: "Services sociaux, sciences sociales et éducation",
  },
  {
    _id: "14",
    label: "Technologies et médias numériques",
  },
  {
    _id: "15",
    label: "Vente, achat et service à la clientèle",
  },
  {
    _id: "16",
    label: "Véhicules motorisés, mécanique et transport",
  },
];

export const listCompanyType = [
  {
    _id: "1",
    label: "Startup 1-10 employés"
  },
  {
    _id: "2",
    label: "Petite entreprise 10-100 employés"
  },
  {
    _id: "3",
    label: "Moyenne entreprise 100-500 employés"
  },
  {
    _id: "4",
    label: "Grande entreprise +500 employés"
  },
  {
    _id: "5",
    label: "Organisation à but non lucratif"
  },
  {
    _id: "6",
    label: "techniques"
  },
  {
    _id: "7",
    label: "Fonction publique provinciale"
  },
  {
    _id: "8",
    label: "Fonction publique fédérale"
  }
];

export const listCompanyValues = [
  {
    _id: "1",
    label: "Altruisme",
  },
  {
    _id: "2",
    label: "Autonomie",
  },
  {
    _id: "3",
    label: "Ambition",
  },
  {
    _id: "4",
    label: "Aptitudes",
  },
  {
    _id: "5",
    label: "Audace",
  },
  {
    _id: "6",
    label: "Bienveillance",
  },
  {
    _id: "7",
    label: "Collaboration",
  },
  {
    _id: "8",
    label: "Compétence",
  },
  {
    _id: "9",
    label: "Compétition",
  },
  {
    _id: "10",
    label: "Confiance",
  },
  {
    _id: "11",
    label: "Éthique de travail",
  },
  {
    _id: "12",
    label: "Égalité",
  },
  {
    _id: "13",
    label: "Équilibre",
  },
  {
    _id: "14",
    label: "Esprit d’équipe",
  },
  {
    _id: "15",
    label: "Excellence",
  },
  {
    _id: "16",
    label: "Fidélité",
  },
  {
    _id: "17",
    label: "Flexibilité",
  },
  {
    _id: "18",
    label: "Habileté",
  },
  {
    _id: "19",
    label: "Honnêteté",
  },
  {
    _id: "20",
    label: "Innovation",
  },
  {
    _id: "21",
    label: "Intégrité",
  },
  {
    _id: "22",
    label: "Liberté",
  },
  {
    _id: "23",
    label: "Ouverture d’esprit",
  },
  {
    _id: "24",
    label: "Passion",
  },
  {
    _id: "25",
    label: "Partage",
  },
  {
    _id: "26",
    label: "Performance",
  },
  {
    _id: "27",
    label: "Persévérance",
  },
  {
    _id: "28",
    label: "Plaisir",
  },
  {
    _id: "29",
    label: "Polyvalence",
  },
  {
    _id: "30",
    label: "Respect des individus",
  },
  {
    _id: "31",
    label: "Respect de l’environnement",
  },
  {
    _id: "32",
    label: "Responsabilité sociale",
  },
  {
    _id: "33",
    label: "Qualité",
  },
];

export const listWorkRelationship = [
  {
    _id: "1",
    title: "Collaboratif",
    content:
      "L'entraide, le partage et l’appui des collègues règnent. Le travail est fait généralement en équipe et tous les membres sont consultés.",
  },
  {
    _id: "2",
    title: "Conviviale",
    content:
      "La bonne humeur et l'enthousiasme sont toujours au rendez-vous, il en faut peu pour être heureux. Le travail est fait de manière très décontractée.",
  },
  {
    _id: "3",
    title: "Intellectuel",
    content:
      "Chacun est un expert dans ce qu’il fait. Les résultats s’accomplissent en équipe mais, chacun effectue son travail individuellement.",
  },
  {
    _id: "4",
    title: "Compétitif",
    content:
      "L'esprit de compétition est très développé à l’interne, les récompenses se gagnent sous pression. Il faut faire partie des meilleurs.",
  },
  {
    _id: "5",
    title: "Autonome",
    content:
      "Chacun s'organise à sa manière, le travail est effectué de façon autonome.",
  },
  {
    _id: "6",
    title: "Directif",
    content:
      "Les taches de travail sont précises dans l'organisation, tout le monde doit respecter les directives établies par le supérieur immédiat.",
  },
];

export const listStructure = [
  {
    _id: "1",
    title: "Structure hiérarchique",
    text: "Structure permettant un travail linéaire ainsi qu’une communication descendante.",
    imgDetails: Hierarchique(
      settingsEnterprise?.customColor?.rgba08 || "#FFA37B",
      settingsEnterprise?.customColor?.rgba1 || "#FA763D"
    ),
    icon:HierarchiqueIcon(
      settingsEnterprise?.customColor?.rgba08 || "#FFA37B",
      settingsEnterprise?.customColor?.rgba1 || "#FA763D"
    )
  },
  {
    _id: "2",
    title: "Structure matricielle",
    text: "Structure gardant une hiérarchie tout en cherchant à ouvrir les lignes de communication et de collaboration entre les différents paliers",
    imgDetails: Matricielle(
      settingsEnterprise?.customColor?.rgba08 || "#FFA37B",
      settingsEnterprise?.customColor?.rgba1 || "#FA763D"
    ),
    icon:MatricielleIcon(
      settingsEnterprise?.customColor?.rgba08 || "#FFA37B",
      settingsEnterprise?.customColor?.rgba1 || "#FA763D"
    )

  },
  {
    _id: "3",
    title: "Structure par réseaux",
    text: "Structure entièrement aplatie. Tout le monde est considéré comme égal. Souvent appelées organisations autogérées.",
    imgDetails: Reseaux(
      settingsEnterprise?.customColor?.rgba08 || "#FFA37B",
    ),
    icon:ReseauxIcon(
      settingsEnterprise?.customColor?.rgba08 || "#FFA37B",
    )
  },
  {
    _id: "4",
    title: "Structure matricielle et réseaux",
    text: "Structure hybride combinant des groupes par réseaux tout en étant connectés de manière matricielle. Cette structure permet aux groupes d’évoluer de façon indépendante tout en gardant une communication transversale.",
    imgDetails: MatricielleAndReseaux(
      settingsEnterprise?.customColor?.rgba02 || "#FFF4EF",
      settingsEnterprise?.customColor?.rgba03 || "#FFE9E0",
      settingsEnterprise?.customColor?.rgba08 || "#FFA37B",
      settingsEnterprise?.customColor?.rgba1 || "#FA763D"
    ),
    icon:MatricielleReseauxIcon(
      settingsEnterprise?.customColor?.rgba08 || "#FFA37B",
      settingsEnterprise?.customColor?.rgba1 || "#FA763D"
    )
  },
  {
    _id: "5",
    title: "Structure holacratique",
    text: "Structure permettant d'évoluer en groupes 100% autonomes comportant des tâches et responsabilités variées, Il n'existe plus de chefs, L'holacratie revient à la raison d'être de l'entreprise et du rôle de chacun",
    imgDetails: Holacratique(
      settingsEnterprise?.customColor?.rgba02 || "#FFF4EF",
      settingsEnterprise?.customColor?.rgba05 || "#FA966B",
      settingsEnterprise?.customColor?.rgba08 || "#FFA37B",
      settingsEnterprise?.customColor?.rgba1 || "#FA763D"
    ),
    icon:HolacratiqueIcon(
      settingsEnterprise?.customColor?.rgba08 || "#FFA37B",
      settingsEnterprise?.customColor?.rgba1 || "#FA763D"
    )
  },
];

export const listCareerEvolution = [
  {
    _id: "1",
    label: "Nous offrons la stabilité avant tout, et pas nécessairement plus de responsabilités pour le candidat s’il ne le souhaite pas"
  },
  {
    _id: "2",
    label: "Nous pouvons nous ajuster entre la stabilité et l’évolution de carrière professionnelle du candidat tout dépendamment de ces besoins"
  },
  {
    _id: "3",
    label: "Nous offrons la possibilité d'évolution de carrière constante, tant que le candidat à les compétences pour le faire et qu’il aime ce qu’il fait"
  },
  {
    _id: "4",
    label: "Nous voulons faire évoluer rapidement le candidat, même si cela signifie devoir changer souvent de poste et de lieu"
  }
];

export const listSkillsDevelopment = [
  {
    _id: "1",
    label: "Nous n’intervenons pas sur les formations nécessaires au développement des compétences du poste, Le candidat doit être autonome"
  },
  {
    _id: "2",
    label: "Nous offrons la possibilité de formations à l’interne sans toutefois être obligatoires pour les candidats"
  },
  {
    _id: "3",
    label: "Notre entreprise trouve important de former régulièrement les employés pour qu’ils soient toujours à jour"
  }
];

export const listWorkingEnv = [
  {
    _id: "1",
    label: "Eclairage naturel"
  },
  {
    _id: "2",
    label: "Vue sur l'extérieur"
  },
  {
    _id: "3",
    label: "Bureau ouvert"
  },
  {
    _id: "4",
    label: "Bureau fermé"
  },
  {
    _id: "5",
    label: "Salle de détente"
  },
  {
    _id: "6",
    label: "Salle de loisirs"
  },
  {
    _id: "7",
    label: "Salle de sport"
  },
  {
    _id: "8",
    label: "Salle de vestiaire"
  },
  {
    _id: "9",
    label: "Terrasses et espaces extérieurs"
  },
  {
    _id: "10",
    label: "Cafétéria"
  },
  {
    _id: "11",
    label: "Salle-à-manger"
  },
  {
    _id: "12",
    label: "Environnement sans distractions"
  },
  {
    _id: "13",
    label: "Température adapté"
  },
  {
    _id: "14",
    label: "Salle de collaboration et innovation"
  },
  {
    _id: "15",
    label: "Espaces de travail flexibles"
  },
  {
    _id: "16",
    label: "Lieu de prière"
  },
  {
    _id: "17",
    label: "Une garderie"
  },
  {
    _id: "18",
    label: "Jeux de divertissement (tables billard, ping pong)"
  }
];

export const listNearbyEnv = [
  {
    _id: "1",
    label: "Des restaurants"
 },
  {
    _id: "2",
    label: "Un parc"
 },
  {
    _id: "3",
    label: "Un bar"
 },
  {
    _id: "4",
    label: "Un stationnement"
 },
  {
    _id: "5",
    label: "Un gym"
 },
  {
    _id: "6",
    label: "Une épicerie"
 },
  {
    _id: "7",
    label: "Une pharmacie"
 },
  {
    _id: "8",
    label: "Un café"
 },
  {
    _id: "9",
    label: "Une garderie"
 },
  {
    _id: "10",
    label: "Une station de métro"
  },
  {
    _id: "11",
    label: "Un hôpital"
  },
  {
    _id: "12",
    label: "Un garage d’auto"
  },
  {
    _id: "13",
    label: "Centres d’achat"
  },
  {
    _id: "14",
    label:  "Un arrêt d’autobus"
  },
  {
    _id: "15",
    label: "Un arrêt de train de banlieue"
  },
  {
    _id: "16",
    label: "Un rac à vélo"
  }
];

export const listSchedule = [
  {
    _id: "1",
    label: "Horaire fixe",
  },
  {
    _id: "2",
    label: "Horaires variables et/ou décalés",
  },
  {
    _id: "3",
    label: "Horaires d'été",
  },
  {
    _id: "4",
    label: "Horaire flexible",
  },
  {
    _id: "8",
    label: "Heures supplémentaires",
  },
  {
    _id: "9",
    label: "Partage de poste",
  },
  {
    _id: "10",
    label: "Heures compressées",
  },
  {
    _id: "11",
    label: "Horaire traditionnel",
  },
  {
    _id: "5",
    label: "Horaire étudiant",
  },
  // {
  //   _id: "6",
  //   label: "Collaborateur proche de la retraite ",
  // },
  // {
  //   _id: "7",
  //   label: "collaborateur qui souhaite s’occuper d'un proche",
  // },
];

export const listWorkplace = [
  {
    _id: "1",
    label: "Présentiel seulement"
  },
  {
    _id: "2",
    label: "Télétravail à la demande"
  },
  {
    _id: "3",
    label: "Télétravail 1 jour/semaine"
  },
  {
    _id: "4",
    label: "Télétravail jusqu'à 2 jour/semaine"
  },
  {
    _id: "5",
    label: "Télétravail jusqu'à 3 jour/semaine"
  },
  {
    _id: "6",
    label: "Télétravail jusqu'à 4 jour/semaine"
  },
  {
    _id: "7",
    label: "Full remote"
  },
  {
    _id: "8",
    label: "Télétravail à distance longue durée (+ de 2 semaines)"
  }
];

export const listVacation = [
  {
    _id: "1",
    label: "Congés légaux"
  },
  {
    _id: "2",
    label: "Congés personnels et maladies sans justification"
  },
  {
    _id: "3",
    label: "Congés maladie (illimités)"
  },
  {
    _id: "4",
    label: "Reprise de temps en congé"
  },
  {
    _id: "5",
    label: "Bonification du congé parental"
  },
  {
    _id: "6",
    label:  "Congés des fêtes"
  },
  {
    _id: "7",
    label: "Congés événements de vie (mariage, déménagement, etc.)"
  },
  {
    _id: "8",
    label: "Congés spéciaux pour les étudiants"
  },
  {
    _id: "9",
    label: "Congés sans solde illimités"
  },
  {
    _id: "10",
    label: "Possibilité de morceler les vacances (heures/jours)"
  },
];

export const listConciliation = [
  {
    _id: "1",
    label: "Aucun programme mis en place"
  },
  {
    _id: "2",
    label: "Banque d'heures offerte pour du bénévolat"
  },
  {
    _id: "3",
    label: "Banque d'heures offerte pour du sport/loisir"
  },
  {
    _id: "4",
    label: "Présence possible des enfants au bureau"
  },
  {
    _id: "5",
    label: "Service de télémedecine pour la famille"
  },
  {
    _id: "6",
    label: "Programme d’aide aux employés"
  },
  {
    _id: "7",
    label: "Journées tempêtes/écoles fermée"
  },
  {
    _id: "8",
    label: "Collaborateur proche de la retraite",
  },
  {
    _id: "9",
    label: "Collaborateur qui souhaite s'occuper d'un proche",
  },
];

export const listManagementType = [
  {
    _id: "1",
    label: "Basée sur les methodes agiles"
  },
  {
    _id: "2",
    label: "Basée sur les taches et les résultats"
  }
];

export const listManagementStyle = [
  {
    _id: "1",
    title: "L’expert ",
    content:
      "Nous offrons la stabilité avant tout, et pas nécessairement plus de responsabilités pour le candidat s’il ne le souhaite pas.",
  },
  {
    _id: "2",
    title: "Le visionnaire",
    content:
      "Le manager veut faire avancer l'entreprise et a des convictions fortes sur l'avenir. Ce style de gestion est orienté en fonction des valeurs de l’organisation. Vous devez croire fortement à ce que votre entreprise fait.  ",
  },
  {
    _id: "3",
    title: "Le leader",
    content:
      "Le manager veut réunir son équipe autour d'un projet commun et souhaite que tout le monde participe à part égale, lui y compris.",
  },
  {
    _id: "4",
    title: "Le fixé objectifs",
    content:
      "L'atteinte des objectifs est prioritaire. Les taches à accomplir sont pas ambiguës et le rythme de travail est accéléré. Ce style de gestion est bon pour les gens qui aiment et qui travaillent bien sous pression.",
  },
  {
    _id: "5",
    title: "L’intuitif",
    content:
      "Le manager prend des décisions à partir de ces connaissances personnelles et professionnelles. Ce style de gestion est bon pour les gens qui aiment la spontanéité et la résolution de problème au jour le jour.",
  },
  {
    _id: "6",
    title: "L’individuel",
    content:
      "Le manager à tendance à prendre des décisions de manière autonome. Les taches de travail sont claires et le travail se fait de façon individuelle entre tous les départements. Ce style est bon pour les gens qui aiment travailler de manière autonome."
  }
];

export const listAccessibility = [
  {
    _id: "1",
    label: "Accessibilité personne à mobilité réduite"
  },
  {
    _id: "2",
    label: "En cours d'amélioration des espaces PMR"
  },
  {
    _id: "3",
    label: "Accessibilité pour une personne malvoyante"
  },
  {
    _id: "4",
    label: "Accessibilité personne malentendante"
  },
  {
    _id: "5",
    label: "Mobilier adapté"
  },
  {
    _id: "6",
    label: "Rampes d'accès mobiles"
  },
  {
    _id: "7",
    label: "Rampes d'accès"
  },
  {
    _id: "8",
    label: "Dispositifs visuels et sonores"
  },
  {
    _id: "9",
    label: "Système d'appel aux secours"
  },
  {
    _id: "10",
    label: "Plateforme élévatrice"
  },
  {
    _id: "11",
    label: "Panneau en braille"
  },
  {
    _id: "12",
    label: "Barre d'appui"
  },
  {
    _id: "13",
    label: "Surfaces anti-dérapante"
  },
  {
    _id: "14",
    label: "Ascenseur"
  },
  {
    _id: "15",
    label: "Stationnement pour personne en situation de handicap"
  }
  // {
  //   _id: "24",
  //   label: "Toilettes aménagés"
  // },
  // {
  //   _id: "25",
  //   label: "Place de parking handicapés"
  // },
  // {
  //   _id: "26",
  //   label: "Dispositif mis en place pour les mal entendants"
  // },
  // {
  //   _id: "27",
  //   label: "Braille"
  // }
];

export const listSocialAdvantages = [
  {
    _id: "1",
    label: "Avantages Sociaux"
  },
  {
    _id: "2",
    label: "Assurance santé et médicaments"
  },
  {
    _id: "3",
    label: "Assurance soins dentaires"
  },
  {
    _id: "4",
    label: "Assurance soins de la vue"
  },
  {
    _id: "5",
    label: "Assurance invalidité"
  },
  {
    _id: "6",
    label: "Assurance vie"
  },
  {
    _id: "7",
    label: "Assurance voyage"
  },
  {
    _id: "8",
    label: "Prestations de maternité ou parentales"
  },
  {
    _id: "9",
    label: "Programme d'aide aux employés"
  },
  {
    _id: "10",
    label: "Programme de remboursement des frais de scolarité"
  },
  {
    _id: "11",
    label: "Régime d'épargne retraite"
  },
  {
    _id: "12",
    label: "Augmentations de salaire prédéfinies"
  },
  {
    _id: "13",
    label: "Primes annuelles ou semestrielles"
  },
  {
    _id: "14",
    label: "Partage des bénéfices"
  },
  {
    _id: "15",
    label: "Avance salariale"
  },
  {
    _id: "16",
    label: "Rémunération différée"
  },
  {
    _id: "17",
    label: "Activités sociales"
  },
  {
    _id: "18",
    label: "Rabais pour les employés"
  },
  {
    _id: "19",
    label: "Programmes de bien-être"
  }
];


//ERROR
export const ERROR = "error";
// NUMBER CHARACTER 
export const NUMBER_CHARACTER = 60;
export const SUCCESS= "success";

export const PatternLinkedin = /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(in|company|pub|profile)\/([A-z0-9_-]+\/?)+$/;
export const PatternEmail = /\S+@\S+\.\S+/;